export const MSAL_CLIENT_ID = `${process.env.REACT_APP_MSAL_CLIENTID}`;
export const MSAL_AUTHORITY = `${process.env.REACT_APP_MSAL_AUTHORITY}`;
export const MSAL_READ_SCOPE = `${process.env.REACT_APP_READ_SCOPE}`;
export const MSAL_WRITE_SCOPE = `${process.env.REACT_APP_WRITE_SCOPE}`;
export const WEPAY_ENVIRONMENT = `${process.env.REACT_APP_WEPAY_ENVIRONMENT}`;
export const WEPAY_APP_ID = `${process.env.REACT_APP_WEPAY_APP_ID}`;
export const WEPAY_API_VERSION = `${process.env.REACT_APP_WEPAY_API_VERSION}`;
export const AI_INSTRUMENTATION_KEY = `${process.env.REACT_APP_AI_INSTRUMENTATION_KEY}`;
